// Actions
import { TypedAction } from "@ms/uno-fluxcore/lib/local/actions/Action";
import { ActionType } from "../ActionType";
// Constants
import { CopilotFailureReason } from "@ms/uno-constants/lib/local/CopilotConstants";
import { TaskAccessContext } from "@ms/planner-models/lib/local/client/planner/Enumerations";
export class SetCategoryLabelModeAction extends TypedAction(ActionType.SetCategoryLabelModeAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            isCollapsed: String(this.isCollapsed)
        };
    }
    constructor(accessContext, contextEntityId, isCollapsed){
        super(), this.accessContext = accessContext, this.contextEntityId = contextEntityId, this.isCollapsed = isCollapsed;
    }
}
export class SetTaskFilterAction extends TypedAction(ActionType.SetTaskFilterAction) {
    loggingData() {
        const taskAccessContext = this.viewId.partitionKey;
        return {
            ...super.loggingData(),
            taskAccessContext: taskAccessContext != null ? String(TaskAccessContext[taskAccessContext]) : "null",
            filterCount: String(this.filter.filterCount)
        };
    }
    constructor(viewId, filter){
        super(), this.viewId = viewId, this.filter = filter;
    }
}
export class SetTaskGroupingStateAction extends TypedAction(ActionType.SetTaskGroupingStateAction) {
    loggingData() {
        const taskAccessContext = this.viewId.partitionKey;
        return {
            ...super.loggingData(),
            accessContext: taskAccessContext != null ? String(TaskAccessContext[taskAccessContext]) : "null",
            taskGrouping: this.groupingState
        };
    }
    constructor(viewId, groupingState){
        super(), this.viewId = viewId, this.groupingState = groupingState;
    }
}
export class SetTeamsExpandedStateAction extends TypedAction(ActionType.SetTeamsExpandedStateAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            isExpanded: String(this.isExpanded)
        };
    }
    constructor(teamId, isExpanded){
        super(), this.teamId = teamId, this.isExpanded = isExpanded;
    }
}
export class SetPlanFilterAction extends TypedAction(ActionType.SetPlanFilterAction) {
    constructor(filter){
        super(), this.filter = filter;
    }
}
export class SetSortCriteriaAction extends TypedAction(ActionType.SetSortCriteriaAction) {
    constructor(viewId, sortCriteria){
        super(), this.viewId = viewId, this.sortCriteria = sortCriteria;
    }
}
export class SetGridColumnWidthAction extends TypedAction(ActionType.SetGridColumnWidthAction) {
    constructor(viewId, columnId, columnWidth){
        super(), this.viewId = viewId, this.columnId = columnId, this.columnWidth = columnWidth;
    }
}
export class SetLeftNavExpandedAction extends TypedAction(ActionType.SetLeftNavExpandedAction) {
    constructor(isExpanded){
        super(), this.isExpanded = isExpanded;
    }
}
export class SetFABStateAction extends TypedAction(ActionType.SetFABStateAction) {
    loggingData() {
        return {
            mode: this.state.mode
        };
    }
    constructor(state){
        super(), this.state = state;
    }
}
/**
 * Action to set the copilot pane state.
 */ export class SetCopilotPaneStateAction extends TypedAction(ActionType.SetCopilotPaneStateAction) {
    loggingData() {
        return {
            state: this.state,
            failureReason: this.failureReason
        };
    }
    constructor(state, failureReason = CopilotFailureReason.None){
        super(), this.state = state, this.failureReason = failureReason;
    }
}
/**
 * Action to set the Copilot sidecar state (open/collapsed).
 */ export class SetCopilotSidecarStateAction extends TypedAction(ActionType.SetCopilotSidecarStateAction) {
    loggingData() {
        return {
            open: String(this.state.open),
            collapsed: String(this.state.collapsed ?? false),
            withInitialPrompt: String(!!this.state.initialHandInContext)
        };
    }
    constructor(state){
        super(), this.state = state;
    }
}
/**
 * Action to request running an imperative UI command (e.g. from an Iris campaign CTA).
 */ export class SetUiCommandRequestAction extends TypedAction(ActionType.SetUiCommandRequestAction) {
    loggingData() {
        return {
            command: String(this.command)
        };
    }
    constructor(command){
        super(), this.command = command;
    }
}
/**
 * Action to set whether the Copilot DAB should be expanded by default.
 */ export class SetDabDefaultExpandedAction extends TypedAction(ActionType.SetDabDefaultExpandedAction) {
    constructor(isDefaultExpanded){
        super(), this.isDefaultExpanded = isDefaultExpanded;
    }
}
export class SetScreenWidthAction extends TypedAction(ActionType.SetScreenWidthAction) {
    constructor(width){
        super(), this.width = width;
    }
}
export class SetAddGoalRowVisibilityAction extends TypedAction(ActionType.SetAddGoalRowVisibilityAction) {
    constructor(visible){
        super(), this.visible = visible;
    }
}
export class SetTaskEditorRenderModeAction extends TypedAction(ActionType.SetTaskEditorRenderModeAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            renderMode: this.taskEditorRenderMode
        };
    }
    constructor(taskEditorRenderMode){
        super(), this.taskEditorRenderMode = taskEditorRenderMode;
    }
}
export class SetTaskEditorActiveSidePanelAction extends TypedAction(ActionType.SetTaskEditorActiveSidePanelAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            pane: this.pane
        };
    }
    constructor(pane){
        super(), this.pane = pane;
    }
}
export class SetGanttZoomScaleAction extends TypedAction(ActionType.SetGanttZoomScaleAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            ganttZoomScale: String(this.ganttZoomScale),
            viewType: this.viewType
        };
    }
    constructor(viewId, ganttZoomScale, viewType){
        super(), this.viewId = viewId, this.ganttZoomScale = ganttZoomScale, this.viewType = viewType;
    }
}
export class SetTaskEditorSelectedTabAction extends TypedAction(ActionType.SetTaskEditorSelectedTabAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            taskId: this.taskId,
            selectedTab: this.selectedTab
        };
    }
    constructor(taskId, selectedTab){
        super(), this.taskId = taskId, this.selectedTab = selectedTab;
    }
}
export class SetAgentOutputUnseenAction extends TypedAction(ActionType.SetAgentOutputUnseenAction) {
    loggingData() {
        return {
            ...super.loggingData(),
            taskId: this.taskId,
            unseen: String(this.unseen)
        };
    }
    constructor(taskId, unseen){
        super(), this.taskId = taskId, this.unseen = unseen;
    }
}
